import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CacheService } from '../../../../../projects/common/src/app/services/cache.service';
import { ILoopByOperatorResponse } from '../interfaces/report-loop-by-operator';
import { IOutputFilter } from '../../core/interfaces/output-filter';
import { catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { Logger } from '../../../../../projects/common/src/app/classes/logger';
import { CommunicationService } from '../../../services/communication/communication.service';
import { UrlBuilderService } from 'projects/communication/src/app/services';

@Injectable({
  providedIn: 'root',
})
export class ReportLoopByOperatorService extends Logger {
  private baseUrl: string;
  constructor(
    private cacheService: CacheService,
    private http: HttpClient,
    private communicationService: CommunicationService,
    private urlBuilder: UrlBuilderService,
  ) {
    super();
    this.baseUrl = this.urlBuilder.serverBasePath;
  }

  /**
   * Function to get filtered result for loopByOperator report by selected filters
   *
   * @param selectedFilters Filters selected by user to get data
   */
  public getLoopByOperatorFilterResult(selectedFilters: IOutputFilter, isTruck: boolean = false): Promise<ILoopByOperatorResponse> {
    const params = this.setParams(selectedFilters);
    const urlEndpoint = isTruck ? 'GetLoopsByTruckOperatorReport' : 'GetLoopsByOperatorReport';
    const url = `${this.baseUrl}/Report/${urlEndpoint}`;
    return this.communicationService
      .get(url, params)
      .pipe(catchError((err) => this.handleError(err)))
      .toPromise();
  }

  /**
   * Get excel from GetChecklistReportDetailDocument endpoint
   */
  public GetLoopByOperatorReportExcel(selectedFilters: IOutputFilter, isTruck: boolean = false): Observable<any> {
    const params = this.setParams(selectedFilters);
    const urlEndpoint = isTruck ? 'GetLoopsByTruckOperatorReportDocument' : 'GetLoopsByOperatorReportDocument';
    const url = `${this.urlBuilder.apiUrl}/Report/${urlEndpoint}`;
    return this.http.get(url, { params, responseType: 'blob' }).pipe(catchError((error) => throwError(() => error.error)));
  }

  /**
   * Function to set params and send selected filters to request
   *
   * @param selectedFilters Filters selected to save params
   */
  private setParams(selectedFilters: IOutputFilter): any {
    const companyId = this.cacheService.local('session').user.company.id;

    return {
      startDate: selectedFilters.startDate,
      endDate: selectedFilters.endDate,
      shiftId: String(selectedFilters.shiftId),
      mineId: String(selectedFilters.zoneId),
      operatorList: String(selectedFilters.operatorId),
      companyId,
    };
  }

  /**
   * Handle error
   *
   * @param err error
   */
  private handleError(err: any): Observable<any> {
    this.error(err);
    return throwError(err);
  }
}
